// Module
var code = "<div class=\"custom-input-percentage\"> <input text-format=\"number\" class=\"{{vm.inputClass}}\" ng-model=\"vm.inputModel\" style=\"\" ng-change=\"vm.inputChange()\"/> </div> ";
// Exports
module.exports = code;